import { mockApiImpl } from "./impl";

export const donations = {
  submitContact: mockApiImpl.submitContact,
  sendOtp: mockApiImpl.sendOtp,
  verifyOtp: mockApiImpl.verifyOtp,
  sendDonationEmailCustom: mockApiImpl.sendDonationEmailCustom,
  subscribeNewsletter: mockApiImpl.subscribeNewsletter,
  unsubscribeNewsletter: mockApiImpl.unsubscribeNewsletter,
  getAdminLoginContent: mockApiImpl.getAdminLoginContent,
  getStats: mockApiImpl.getStats,
  getEvents: mockApiImpl.getEvents,
  getRecentDonors: mockApiImpl.getRecentDonors,
  createDonationOrder: mockApiImpl.createDonationOrder,
  verifyDonation: mockApiImpl.verifyDonation,
  getDonationStatus: mockApiImpl.getDonationStatus,
  getDocumentData: mockApiImpl.getDocumentData,
};
